<template>
  <AppBarLayout>
    <template #default>
      <div
        ref="containerRecommendations"
        :class="`${
          isDataAssessment === API_STATUS.NO_DATA ? 'no__data' : 'main'
        } tw-overflow-x-hidden`"
      >
        <BrandPattern4 page="APPBARLAYOUT" />
        <BackgroundComponent ref="backgroundRef" />

        <ActivePathWrapper
          :active-hierarchy="[
            getComponentUiText('app-menu-assess-1'),
            getComponentUiText('app-menu-submenu-assess-recommendations-1'),
          ]"
        />

        <div v-if="isDataAssessment === API_STATUS.FETCHING"></div>
        <div v-else-if="isDataAssessment === API_STATUS.NO_DATA">
          <div class="tw-flex tw-justify-center tw-mt-[185px]">
            <NoDataRecommentdations />
          </div>
        </div>
        <div
          v-else-if="isDataAssessment === API_STATUS.HAS_DATA"
          id="click-box-container"
          class="tw-w-full recommendations-container"
        >
          <div
            class="header-container tw-bg-[#FFFFFF] tw-py-[55px] md:tw-px-[60px] tw-px-[10px] tw-w-full tw-border-x-0 tw-border-t-0 tw-border-b-[1px] !tw-border-solid !tw-border-[#EFF0F1]"
          >
            <div
              class="tw-flex tw-justify-between tw-items-center section-title"
            >
              <p class="tw-my-0 title-text">
                <span class="title tw-text-2xl tw-font-semibold">
                  {{
                    getChecklistSelected?.checklistId !==
                    checkLists[0]?.checklistId
                      ? `${getComponentUiText(
                          "app-assess-recommendations-title",
                        )}:`
                      : getComponentUiText("app-assess-recommendations-title")
                  }}</span
                >
                <span
                  v-if="
                    getChecklistSelected &&
                    isSelected &&
                    (getChecklistSelected.checklistDateCreated ||
                      getChecklistSelected?.checklistDateReporting) &&
                    getChecklistSelected.checklistId !==
                      checkLists[0].checklistId
                  "
                  data-cy="recommendation-checklist-name"
                  class="tw-font-normal tw-leading-[100%] tw-ml-[10px] md:tw-text-[22px] tw-text-[18px] tw-text-[#211F58]"
                  >{{ getChecklistSelected?.checklistName }} -
                  {{
                    convertUTCTimeToLocalTime(
                      getChecklistSelected?.checklistDateReporting
                        ? getChecklistSelected?.checklistDateReporting
                        : getChecklistSelected?.checklistDateCreated,
                    )
                  }}
                </span>
              </p>
              <p
                v-if="loadingChecklists"
                class="tw-ml-[10px] custom-global-skeleton tw-w-[250px] tw-h-full tw-rounded-[6px]"
              ></p>
              <div
                id="recom-assessment-switcher"
                class="header__dot tw-items-center tw-flex tw-justify-center"
              >
                <AssessmentSwitcherDropdown
                  :data="checkLists"
                  :is-show-landing-page="true"
                  :is-loading="loadingChecklists"
                  :is-no-data="isDataAssessment === API_STATUS.NO_DATA"
                  @on-select-checklist="onSelectChecklist"
                />
              </div>
            </div>

            <NoteInfo
              v-if="notInfoVisible"
              class="custom-info"
              @close="() => (notInfoVisible = false)"
            >
              <span class="tw-text-[#211F58] tw-text-[15px]">{{
                getComponentUiText("app-assess-recommendations-tip-top")
              }}</span>
              <!--              <a -->
              <!--                href="#" -->
              <!--                class="tw-underline tw-text-[#387DFF] tw-text-[15px]" -->
              <!--                >{{ -->
              <!--                  getComponentUiText( -->
              <!--                    "app-assess-recommendations-tip-top-link-1", -->
              <!--                  ) -->
              <!--                }}</a -->
              <!--              > -->
            </NoteInfo>
            <div class="overview-container tw-flex tw-gap-[20px] tw-mt-[40px]">
              <!-- Cyber Health Score -->
              <div
                class="tw-flex-1 tw-bg-[#FCFCFC] tw-h-[184px] tw-border-solid tw-border tw-border-[#EFF0F1] tw-rounded-md tw-text-[#211F58]"
              >
                <CyberHealthScore
                  :title="
                    getComponentUiText(
                      'app-assess-recommendations-cyber-health-score-title-1',
                    )
                  "
                  :is-loading="loadingActionTable"
                  :data="dataScore"
                  :score="isSelected ? score : { currentSCore: 0, maxScore: 0 }"
                  :type="'scoreIncrease'"
                />
              </div>
              <!-- Risk -->
              <div
                class="tw-flex-1 tw-bg-[#FCFCFC] tw-h-[184px] tw-border-solid tw-border tw-border-[#EFF0F1] tw-rounded-md"
              >
                <Risk
                  :list-risk="listRisk"
                  :is-loading="loadingActionTable"
                  :score="dataActionTable?.length"
                />
              </div>
              <!-- Cyber Health Score over time -->
              <div
                class="tw-flex-1 tw-bg-[#FCFCFC] tw-border-solid tw-border tw-border-[#EFF0F1] tw-rounded-md tw-h-[184px]"
              >
                <CyberHealthScoreOverTime
                  :checklists="isSelected ? getCurrentChain() : []"
                  :is-loading="loadingChecklists"
                  :is-recommend-page="true"
                  :checklist-id="isSelected ? currentChecklistReportId : ''"
                />
              </div>
            </div>
          </div>

          <div
            class="body-container tw-flex-col tw-gap-[55px] tw-pt-[41px] tw-px-[60px] tw-pb-[55px] content"
          >
            <!-- Actions -->
            <div id="recom-table-actions" class="tw-w-full">
              <div
                class="section-header-actions tw-w-full tw-flex tw-justify-between tw-items-center tw-mb-[20px]"
              >
                <span class="tw-text-[18px] tw-text-[#211F58] tw-font-semibold"
                  >{{
                    getComponentUiText(
                      "app-assess-recommendations-section-action-1",
                    )
                  }}
                </span>
                <div
                  class="tw-flex tw-items-center tw-justify-end"
                  @click="handleShowOptionActionsBulkAction"
                >
                  <ButtonBulkActions
                    :id-popover="'popover-btn-bulk-action-recommendations-action-table'"
                    :active="
                      seletedActionsRow.length >= 1 && !isChecklistStatusDone
                    "
                    :button-class="`!tw-border tw-border-1 !tw-border-solid !tw-border-[#EFF0F1] tw-mr-[20px]`"
                    :show-more-actions="
                      !isChecklistStatusDone && isShowMoreActions
                    "
                    :show-acction-click="true"
                    :selected-number="seletedActionsRow.length"
                    :is-loading="isUpdatingStatus"
                  >
                    <CustomDropDownItem
                      id="non-effective"
                      :style="'normal'"
                      :id-text="'app-assess-recommend-action-status-mark-completed-1'"
                      @click="
                        bulkUpdateStatus(RECOMMENDATION_ACTION_PcnT.completion)
                      "
                    />
                    <CustomDropDownItem
                      id="non-effective"
                      :style="'normal'"
                      :id-text="'app-assess-recommend-action-status-mark-inprogress-1'"
                      @click="
                        bulkUpdateStatus(RECOMMENDATION_ACTION_PcnT.inProgress)
                      "
                    />
                    <CustomDropDownItem
                      id="non-effective"
                      :style="'normal'"
                      :id-text="'app-assess-recommend-action-status-mark-notstarted-1'"
                      @click="
                        bulkUpdateStatus(RECOMMENDATION_ACTION_PcnT.notStarted)
                      "
                    />
                    <CustomDropDownItem
                      id="non-effective"
                      :style="'normal'"
                      :id-text="'app-assess-recommend-action-reset-status-1'"
                      @click="
                        bulkUpdateStatus(RECOMMENDATION_ACTION_PcnT.reset)
                      "
                    />

                    <CustomDropDownItem
                      id="non-effective"
                      :style="'normal'"
                      :id-text="'app-assess-recommend-action-mark-notquickwin-1'"
                      @click="
                        bulkUpdateStatus(RECOMMENDATION_ACTION_PcnT.isQuickWin)
                      "
                    />
                    <CustomDropDownItem
                      id="non-effective"
                      :style="'normal'"
                      :id-text="'app-assess-recommend-action-mark-quickwin-1'"
                      @click="
                        bulkUpdateStatus(RECOMMENDATION_ACTION_PcnT.nonQuickWin)
                      "
                    />

                    <!--
 <CustomDropDownItem
                      id="non-effective"
                      :style="'danger'"
                      :id-text="'app-assess-recommend-action-delete-actions-1'"
                      @click="bulkActionRemoveActions"
                    /> 
-->
                  </ButtonBulkActions>

                  <ButtonFilter
                    :active="false"
                    :button-class="`tw-mr-[20px] !tw-border !tw-border-1 !tw-border-solid !tw-border-[#EFF0F1]`"
                    :id-popover="'popover-btn-filter-recommendations-action-table'"
                  />

                  <ButtonRisk
                    :text="
                      isActionTableSortByRisk
                        ? getComponentUiText(
                            'app-assess-recommendations-button-sort-title-b-1',
                          )
                        : getComponentUiText(
                            'app-assess-recommendations-button-sort-title-a-1',
                          )
                    "
                    class="tw-mr-[20px] tw-rounded-md tw-border tw-border-solid !tw-border-1 !tw-border-[#EFF0F1] tw-cursor-pointer"
                    :is-active="
                      !!dataActionTable.length && !isChecklistStatusDone
                    "
                    @click="handleClickRisk"
                  >
                    <RiskActionsIcon
                      :color="
                        !!dataActionTable.length && !isChecklistStatusDone
                          ? '#211F58'
                          : '#B7B7B7'
                      "
                    />
                  </ButtonRisk>

                  <IconButton
                    id="recom-btn-add-action"
                    src="/img/plus_icon.svg"
                    :disabled="isChecklistStatusDone"
                    @click="onShowAddNewActionModal"
                  />
                </div>
              </div>
              <ActionsTable
                :is-checklist-status-done="isChecklistStatusDone"
                :data-row="isSelected ? dataActionTable : []"
                :is-loading="loadingActionTable"
                :suggested-selected-rows="seletedSuggestActionsRow"
                :assessment-selected-rows="seletedAssessmentRow"
                @update-selected-rows="handleSelectAction($event)"
                @update-is-sort-by-risk="
                  ($event) => (isActionTableSortByRisk = $event)
                "
                @update-add-action="handleAddAction($event)"
              />
            </div>
            <!-- Suggested Actions -->
            <div id="recom-table-suggested-actions" class="tw-w-full">
              <div
                class="section-header-suggested tw-w-full tw-flex tw-justify-between tw-items-center tw-mb-[20px]"
              >
                <span class="tw-text-[18px] tw-text-[#211F58] tw-font-semibold"
                  >{{
                    getComponentUiText(
                      "app-assess-recommendations-section-suggested-action-1",
                    )
                  }}
                </span>
                <div class="tw-flex tw-items-center tw-justify-end">
                  <div class="tw-flex tw-items-center tw-justify-end">
                    <div
                      class="tw-border-solid tw-rounded-md tw-border-[#EFF0F1] tw-border-[1px] tw-flex tw-justify-between tw-items-center tw-mr-[20px] tw-bg-[#fff] tw-py-[11px] tw-pl-[16px] tw-pr-[11px]"
                    >
                      <span
                        style="letter-spacing: 1px"
                        class="tw-mr-[9px] tw-text-[#211F58] tw-text-[10px] tw-font-semibold tw-leading-[100%]"
                        >{{
                          getComponentUiText(
                            "app-assess-recommend-toggle-show-applied-suggestions-1",
                          )
                        }}
                      </span>
                      <ToggleSwitch
                        color="#01893D"
                        :is-checked="isShowAppliedSuggestions"
                        @update:is-checked="isCheckedToggle"
                      />
                    </div>
                  </div>
                  <div @click="handleShowBulkAction">
                    <ButtonBulkActions
                      :id-popover="'popover-btn-bulk-action-recommendations-suggested-action-table'"
                      :active="
                        seletedSuggestActionsRow.length >= 1 &&
                        !isChecklistStatusDone
                      "
                      :button-class="`!tw-border tw-border-1 !tw-border-solid !tw-border-[#EFF0F1] tw-mr-[20px]`"
                      :show-more-actions="
                        !isChecklistStatusDone && isShowMoreSuggestiongActions
                      "
                      :show-acction-click="true"
                      :selected-number="seletedSuggestActionsRow.length"
                      :is-loading="isBulkAddingActions"
                    >
                      <CustomDropDownItem
                        id="non-effective"
                        :style="'normal'"
                        :id-text="'app-assess-recommendations-suggestion-action-table-bulk-actions-modal-add-actions-1'"
                        @click="bulkActionAddActions"
                      />
                    </ButtonBulkActions>
                  </div>

                  <ButtonFilter
                    :active="false"
                    :button-class="`!tw-mr-[0px] !tw-border !tw-border-1 !tw-border-solid !tw-border-[#EFF0F1]`"
                    :id-popover="'popover-btn-filter-recommendations-suggested-action-table'"
                  />
                </div>
              </div>
              <SuggestionActionsTable
                :is-checklist-status-done="isChecklistStatusDone"
                :is-loading="loadingSuggestedActionTable"
                :data-row="isSelected ? dataSuggestedActionTable : []"
                :is-calling="isLoadingAPI"
                :active-id="itemCheckedId"
                :is-show-loading="isBulkAddingActions ? false : true"
                @update-selected-rows="handleSelectSuggestAction($event)"
                @update-add-action="handleAddAction($event)"
              />
            </div>

            <!-- Assessment Questions -->
            <div id="recom-table-assessment-questions" class="tw-w-full">
              <div
                class="section-header-assessment tw-w-full tw-flex tw-justify-between tw-items-center tw-mb-[20px]"
              >
                <span class="tw-text-[18px] tw-text-[#211F58] tw-font-semibold"
                  >{{
                    getComponentUiText(
                      "app-assess-recommendations-section-assessment-questions-1",
                    )
                  }}
                </span>
                <div
                  class="button-actions-container tw-flex tw-items-center tw-justify-end"
                >
                  <div>
                    <BaseSearchbox
                      :class="[
                        'tw-relative tw-h-[44px] tw-rounded-[6px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-bg-[#ffffff] tw-pt-[10px] tw-pb-[8px] tw-px-[15px] tw-mr-[20px]',
                      ]"
                      :model-value="assessmentQuestionsSearchValue"
                      :placeholder="
                        getComponentUiText('app-header-search-prompt-1')
                      "
                      @update:model-value="
                        ($event) => updateModelAssessmentQuestionsSearch($event)
                      "
                      @on:focus="openRecentSearchModal"
                      @on:blur="closeRecentSearchModal"
                      @keyup.enter="onEnterSearchAssessmentQuestions"
                    />
                    <div
                      v-if="isShowRecentSearch"
                      class="hover-modal tw-w-[284px] tw-absolute tw-z-[2]"
                    >
                      <ModalHoverSearchAssessment
                        :is-search-modal-assessment="false"
                        :search-type-id="SEARCH_TYPE_ID.CL_INPUT"
                        @update-current-value-search="updateCurrentValueSearch"
                      />
                    </div>
                  </div>
                  <div
                    class="block-second tw-flex tw-item-center tw-justify-end"
                  >
                    <ButtonBulkActions
                      :id-popover="'popover-btn-bulk-action-recommendations-assessment-questions-table'"
                      :active="showBulkActionAssessmentQuestions"
                      :button-class="`!tw-border tw-border-1 !tw-border-solid !tw-border-[#EFF0F1] tw-mr-[20px]`"
                      :show-more-actions="isShowMoreAssessmentQuestionActions"
                      :show-acction-click="true"
                      :selected-number="seletedAssessmentRow.length"
                      @click="handleShowBulkActionAssessmentQuestions"
                    >
                      <CustomDropDownItem
                        id="non-effective"
                        :style="'normal'"
                        data-cy="recommentdation-bulk-action-add-actions"
                        :id-text="'app-assess-recommendations-assessment-questions-table-bulk-actions-modal-add-actions-1'"
                        @click="actionAddActions"
                      />
                    </ButtonBulkActions>

                    <ButtonFilter
                      :active="false"
                      :button-class="`!tw-border !tw-border-1 !tw-border-solid !tw-border-[#EFF0F1]`"
                      :id-popover="'popover-btn-filter-recommendations-assessment-questions-table'"
                      :is-margin-right="true"
                    />
                    <div
                      id="chr-display-settings"
                      class="toggle-switch-view tw-relative"
                      :class="
                        isCheckToggleOptionSetting
                          ? 'setting-option-selected'
                          : ''
                      "
                      width="300px"
                      @click="openDisplayOption"
                      @mouseover="isCogHover = true"
                      @mouseout="isCogHover = false"
                    >
                      <label class="tw-cursor-pointer">
                        <span class="tw-p-[14px]">
                          <img
                            v-show="isCheckToggleOptionSetting"
                            src="@/assets/img/setting_option_selected.svg"
                            alt=""
                          />
                          <img
                            v-show="
                              !isCheckToggleOptionSetting &&
                              !isShowToolTip &&
                              !isCogHover
                            "
                            src="@/assets/img/setting_option.svg"
                            alt=""
                          />
                          <img
                            v-show="
                              !isCheckToggleOptionSetting &&
                              (isShowToolTip || isCogHover)
                            "
                            src="@/assets/img/setting_option_active.svg"
                            alt=""
                          />
                        </span>
                      </label>
                    </div>
                    <b-popover
                      ref="popover_option"
                      target="chr-display-settings"
                      placement="bottom-end"
                      click="true"
                      :offset="OFFSET_POPOVER"
                      :custom-class="`custom-actions-popover assessment-display-options`"
                      class="tw-absolute"
                      @show="isShowToolTip = true"
                      @hidden="isShowToolTip = false"
                    >
                      <AssessmentDisplayOptions :list-option="listOption" />
                    </b-popover>
                  </div>
                </div>
              </div>
              <div class="tw-rounded-md tw-bg-[#FFFFFF] tw-w-full">
                <AssessmentQuestionsTable
                  :loading="loadingGetAssessmentQuestions"
                  :table-data="isSelected ? assessmentQuestions : []"
                  :search-key="assessmentQuestionsSearchValue"
                  @update-selected-rows="handleSelectAssessment"
                  @open-modal-create-action="openModalAddAction"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </AppBarLayout>
</template>

<script lang="ts" setup>
import ToggleSwitch from "@/components/common/toggleSwitch.vue";
import AssessmentSwitcherDropdown from "@/components/recommend/assessmentSwitcherDropdown/assessmentSwitcherDropdown.vue";
import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import { getComponentUiText, getTagRelativeRisk } from "@/utils/utilities";
import NoteInfo from "@/components/common/noteInfo.vue";
import BrandPattern4 from "@/components/prospect/brandPattern/brandPattern4.vue";
import { computed, onBeforeUnmount, onMounted, Ref, ref, watch } from "vue";
import BackgroundComponent from "@/components/common/backgroundComponent.vue";
import ButtonBulkActions from "@/components/common/setting/buttonBulkActions.vue";
import ButtonFilter from "@/components/common/setting/buttonFilter.vue";
import IconButton from "@/components/common/iconButton.vue";
import ButtonRisk from "@/components/common/buttonRisk.vue";
import RiskActionsIcon from "@/components/svgs/riskActionsIcon.vue";
import BaseSearchbox from "@/components/common/form/baseSearchbox.vue";
import SuggestionActionsTable from "@/components/recommend/suggestedActionsTable.vue";
import { dataActionTableColumn } from "@/interfaces/recommendations/IActionInterfaces";
import ActionsTable from "@/components/recommend/actionsTable.vue";
import CyberHealthScore from "@/components/recommend/cyberHealthScore.vue";
import CyberHealthScoreOverTime from "@/components/recommend/cyberHealthScoreOverTime.vue";
import Risk from "@/components/recommend/risk.vue";
import AssessmentQuestionsTable from "@/components/assessment/assessmentQuestionsTable.vue";
import {
  IAssessmentDetail,
  IAssessmentQuestionTable,
} from "@/interfaces/assessments/IAssessmentDetails";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IModalMessage } from "@/interfaces/common/common";
import AssessmentDisplayOptions from "@/components/assessment/assessmentDisplayOptions.vue";
import {
  API_STATUS,
  CHECKLISTSTATUS,
  localStorageKey,
  MODAL_NAME,
  RECOMMENDATION_ACTION_PcnT,
  RECOMMENDATION_FORCE_RESORT,
  SEARCH_TYPE_ID,
  statusCode,
  VALUE_SORT_COLUMN_ACTION_MODAL,
} from "@/utils/constants";
import store from "@/store";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";
import NoDataRecommentdations from "./noDataRecommendations.vue";
import { showErrorAPI, showToastMessage } from "@/services/apiRoutes";
import { Checklist } from "@/services/apiRoutes/routes";
import { RISK_VALUE_MAP } from "@/utils/constants";
import isEqual from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import {
  getChecklistGroupMetrics,
  getChecklistGroups,
  putChecklistGroup,
} from "@/services/recommend";
import { useRoute } from "vue-router";
import ModalHoverSearchAssessment from "@/components/assessment/modalHoverSearchAssessment.vue";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";

const OFFSET_POPOVER = 20;
const popover_option: any = ref(null);
const backgroundRef = ref(null);
const notInfoVisible = ref(true);
const isCogHover: Ref<boolean> = ref(false);
const seletedSuggestActionsRow: Ref<any[]> = ref([]);
const seletedActionsRow: Ref<number[]> = ref([]);
const seletedAssessmentRow: Ref<any[]> = ref([]);
const isActionTableSortByRisk: Ref<boolean> = ref(false);
const isDataAssessment: any = ref(API_STATUS.FETCHING);
const loadingGetAssessmentQuestions: Ref<boolean> = ref(false);
const loadingActionTable: Ref<boolean> = ref(false);
const loadingSuggestedActionTable: Ref<boolean> = ref(false);
const assessmentQuestionsSearchValue: Ref<string> = ref("");
const isShowAppliedSuggestions: Ref<boolean> = ref(false);
const loadingChecklists: Ref<boolean> = ref(false);
const isShowMoreSuggestiongActions: Ref<boolean> = ref(false);
const isShowMoreActions: Ref<boolean> = ref(false);
const isShowMoreAssessmentQuestionActions: Ref<boolean> = ref(false);
const showBulkActionAssessmentQuestions: Ref<boolean> = ref(false);
const isShowRecentSearch: Ref<boolean> = ref(false);
const lastCallApiAssessmentQuestionsSearchValue = ref("");
const currentChain = ref(0);
const isLoadingAPI: Ref<boolean> = ref(false);
const isUpdatingStatus: Ref<boolean> = ref(false);
const isBulkAddingActions: Ref<boolean> = ref(false);
const itemCheckedId: Ref<string> = ref("");
let valueSearchAssessmentQuestions = "";
const containerRecommendations = ref(null);

const openDisplayOption = () => {
  setTimeout(() => {
    popover_option?.value?.$emit("show");
  }, 500);
};
const isShowToolTip: Ref<boolean> = ref(false);

watch(seletedAssessmentRow, (value) => {
  if (value.length >= 1) {
    showBulkActionAssessmentQuestions.value = true;
  } else {
    showBulkActionAssessmentQuestions.value = false;
  }
});

const currentOrg = computed(() => store.state.Org.currentOrg);
const isCheckToggleOptionSetting = computed(() => {
  return removeApplied.value;
});
const removeApplied: any = computed(
  () => store.getters["Recommend/getIsHRemoveApplied"],
);
const changeRemoveApplied = (value: any) => {
  store.commit("Recommend/SET_IS_HIDE_REMOVE", value);
};
const listOption = computed(() => [
  {
    title: getComponentUiText("app-assess-recommend-remove-applied-1"),
    value: removeApplied.value,
    action: changeRemoveApplied,
  },
]);

const listRisk = ref([
  {
    text: getComponentUiText("app-assess-recommendations-potential-risk-1"),
    lowNumber: 0,
    mediumNumber: 0,
    highNumber: 0,
    bgLow: "#57B755",
    bgHigh: "#F7553C",
    bgMedium: "#FE9A05",
    colorHigh: "#F7553C",
    bgText: "#D9EDE2",
    textStatus: getComponentUiText("app-assess-recommendations-low-risk-1"),
    colorText: "#01893D",
    isRecommendPotentialRisk: true,
  },
  {
    text: getComponentUiText(
      "app-assess-recommendations-action-table-header-relative-risk-1",
    ),
    relaModerateNumber: 0,
    relaHighNumber: 0,
    relaHighestNumber: 0,
    bgRelaModerate: "#904BD6",
    bgRelaHigh: "#904BD6",
    bgRelaHighest: "#904BD6",
    colorHigh: "#904BD6",
    colorHighest: "#904BD6",
    textStatus: getComponentUiText("app-assess-recommendations-high-risk-1"),
    isRelative: true,
  },
]);

const isChecklistStatusDone = computed(
  () => store.state.Recommend.checklistStatus === CHECKLISTSTATUS.DONE,
);
const dataActionTable = computed(() => {
  if (!isSelected.value) {
    return [];
  }
  const data = store.state.Recommend.recommendChecklistGroupMetrics.map(
    (action: any) => {
      const forecastDate = store.getters["Recommend/getForecastToIdAction"](
        action.checklistGroupId,
      )?.forecastDate;
      return {
        ...action,
        completionDate: forecastDate ? new Date(forecastDate).getTime() : "",
      };
    },
  );

  return data;
});
const dataSuggestedActionTable: Ref<dataActionTableColumn[]> = computed(() => {
  const recommendState = store.state.Recommend;
  if (!recommendState) {
    return [];
  }
  const checklistGroupTemplateMetrics =
    recommendState.ChecklistGroupTemplateMetrics || [];

  const filteredChecklistGroupTemplateMetrics =
    checklistGroupTemplateMetrics.filter((item) => {
      return item?.isSuggested;
    });
  // +props.totalScore.toFixed(2) - +props.firstScore.toFixed(2)
  if (isShowAppliedSuggestions.value) {
    return checklistGroupTemplateMetrics.sort(
      (a, b) =>
        +a.scoreIncreaseTotal.toFixed(2) -
        +a.scoreIncreaseFirstCount.toFixed(2) -
        (+b.scoreIncreaseTotal.toFixed(2) -
          +b.scoreIncreaseFirstCount.toFixed(2)),
    );
  } else {
    return filteredChecklistGroupTemplateMetrics.sort(
      (a, b) =>
        +a.scoreIncreaseTotal.toFixed(2) -
        +a.scoreIncreaseFirstCount.toFixed(2) -
        (+b.scoreIncreaseTotal.toFixed(2) -
          +b.scoreIncreaseFirstCount.toFixed(2)),
    );
  }
});

const getCurrentChain = () => {
  if (
    !checkLists.value[currentChain.value]?.checklistParent ||
    !checkLists.value[currentChain.value]?.checklistParent.length
  ) {
    return [checkLists.value[currentChain.value]];
  }
  return [
    ...checkLists.value[currentChain.value].checklistParent,
    checkLists.value[currentChain.value],
  ];
};

const checkLists = computed<IAssessmentDetail[]>(() => {
  return store.getters["Recommend/getChecklists"] || [];
});

watch(
  () => checkLists.value,
  (value) => {
    const checklistReportRoot = localStorage.getItem(
      localStorageKey.rootChecklistReportId,
    );
    if (checklistReportRoot) {
      const index = value.findIndex(
        (item: any) => item.checklistId === Number(checklistReportRoot),
      );
      if (index !== -1) {
        currentChain.value = index;
      }
      return;
    }
    currentChain.value = 0;
  },
);

const assessmentQuestions: Ref<IAssessmentQuestionTable[]> = computed(() => {
  return store.getters["Recommend/getChecklistAssessmentQuestions"](true);
});

const currentChecklistReportId = computed(
  () => store.getters["Recommend/getChecklistReportId"],
);

const checklistMetrics = computed(
  () => store.getters["Recommend/getRecomChecklistMetrics"],
);

const getChecklistSelected = computed(() => {
  let selectedChecklist;
  checkLists.value.forEach((item: any) => {
    if (item.checklistId === currentChecklistReportId.value) {
      selectedChecklist = item;
    } else {
      item.checklistParent?.forEach((child: any) => {
        if (child.checklistId === currentChecklistReportId.value) {
          selectedChecklist = child;
        }
      });
    }
  });
  return selectedChecklist;
});

const score = computed(() => ({
  currentSCore: checklistMetrics.value?.checklistScore || 0,
  maxScore:
    dataActionTable.value.reduce((acc, cur) => {
      return (
        +(cur.checklistGroupScoreMax || 0) -
        +(cur.checklistGroupScore || 0) +
        acc
      );
    }, 0) + (checklistMetrics.value?.checklistScore || 0),
}));

const dataScore = computed(() => [
  {
    title: getComponentUiText(
      "app-assess-recommendations-cyber-health-score-sub-title-1",
    ),
    id: "currentScore",
    value: checklistMetrics.value?.checklistScore || 0,
  },
  {
    title: getComponentUiText(
      "app-assess-recommendations-cyber-health-score-sub-title-2",
    ),
    id: "maxScore",
    value:
      dataActionTable.value.reduce((acc, cur) => {
        return (
          +(cur.checklistGroupScoreMax || 0) -
          +(cur.checklistGroupScore || 0) +
          acc
        );
      }, 0) + (checklistMetrics.value?.checklistScore || 0),
  },
]);
const route = useRoute();
onMounted(async () => {
  if (route.query.id) {
    await store.dispatch(
      "Recommend/setChecklistReportId",
      Number(route.query.id),
    );
    await store.dispatch(
      "Sharing/setChecklistReportId",
      Number(route.query.id),
    );
  }
  window.addEventListener("click", (e: any) => {
    if (!document.getElementById("click-box-container")?.contains(e.target)) {
      (backgroundRef as any).animation &&
        (backgroundRef as any).animation.reloadToggle();
    }
  });
  initial();
  EventEmitter.on(EmitterEvents.RELOAD_RECOMMENDATION, async (value: any) => {
    loadingGetAssessmentQuestions.value = true;
    loadingActionTable.value = true;
    loadingSuggestedActionTable.value = true;
    await getChecklistGroupMetricsHelper();
    loadingGetAssessmentQuestions.value = false;
    loadingActionTable.value = false;
    loadingSuggestedActionTable.value = false;
  });
  EventEmitter.on(
    EmitterEvents.RELOAD_RECOMMENDATION_ACTIONS,
    async (value: any) => {
      loadingActionTable.value = true;
      loadingSuggestedActionTable.value = true;
      await refreshActions();
      loadingActionTable.value = false;
      loadingSuggestedActionTable.value = false;
    },
  );
  store.dispatch("Assessment/getRecentSearches", {
    searchTypeId: SEARCH_TYPE_ID.CL_INPUT,
  });
});

watch(
  () => currentOrg.value,
  async (newVal, oldVal) => {
    if (
      currentOrg.value &&
      Object.keys(oldVal).length &&
      currentOrg.value.orgId !== oldVal.orgId
    ) {
      containerRecommendations.value?.scrollTo({ top: 0, behavior: "smooth" });
      isSelected.value = false;
      loadingChecklists.value = true;
      localStorage.removeItem(localStorageKey.rootChecklistReportId);
      localStorage.removeItem(localStorageKey.checklistReportId);
      store.dispatch("Recommend/setChecklistReportId", "");
      await store.dispatch("Sharing/setChecklistReportId", "");
      await getCheckListData(true);
    }
  },
  { deep: true },
);

onBeforeUnmount(() => {
  window.removeEventListener("click", () => {});
  EventEmitter.off(EmitterEvents.ADD_NEW_ASSESSMENT_QUESTION_TO_ACTION);
});

const listAssessmentQuestionsSelected = computed(
  () => store.state.Recommend.selectedChecklistAssessmentQuestions,
);

const handleClickRisk = () => {
  if (!dataActionTable.value.length || isChecklistStatusDone.value) return;

  if (
    localStorage.getItem(localStorageKey.isDontShowModalReOrderAction) !==
    "true"
  ) {
    const emitData: IModalMessage = {
      component: MODAL_NAME.MODAL_REORDER_ACTION_MODAL,
      properties: {
        show: true,
        title: getComponentUiText(
          "app-assess-recommendations-modal-reorder-title-1",
        ),
        description: isActionTableSortByRisk.value
          ? getComponentUiText(
              "app-assess-recommendations-modal-reorder-description-b-1",
            )
          : getComponentUiText(
              "app-assess-recommendations-modal-reorder-description-a-1",
            ),
        buttonText: getComponentUiText(
          "app-assess-recommendations-modal-reorder-button-title-reorder-1",
        ),
      },
      events: {
        "update:data": sortData,
      },
    };

    EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
  } else {
    sortData();
  }
};

const sortData = () => {
  isActionTableSortByRisk.value = !isActionTableSortByRisk.value;

  EventEmitter.emit(EmitterEvents.CLICK_SORT_COLUMN_ACTION_TABLE, {
    index: isActionTableSortByRisk.value ? 3 : 2,
    column: {
      sortable: true,
      value: isActionTableSortByRisk.value
        ? VALUE_SORT_COLUMN_ACTION_MODAL.riskReduction
        : VALUE_SORT_COLUMN_ACTION_MODAL.scoreIncreaseTotal,
    },
  });
};

const resetSort = (isAddAll) => {
  if (isAddAll) {
    EventEmitter.emit(EmitterEvents.RESET_SORT_TABLE);
  } else {
    EventEmitter.emit(EmitterEvents.RESET_SORT_TABLE, {
      key: RECOMMENDATION_FORCE_RESORT.isForce,
    });
  }
};

const openModalAddAction = () => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMENDATION_ADD_NEW_ACTION,
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const onShowAddNewActionModal = () => {
  if (seletedAssessmentRow.value.length === 0) {
    const emitData: IModalMessage = {
      component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
      properties: {
        value: {},
        title: getComponentUiText(
          "app-assess-recommendations-action-table-bulk-actions-modal-title-add-no-actions-1",
        ),
        description: getComponentUiText(
          "app-assess-recommendations-action-table-bulk-actions-modal-description-add-no-action-1",
        ),
        buttonText: getComponentUiText(
          "app-assess-recommendations-action-table-bulk-actions-modal-button-add-no-action-1",
        ),
        buttonRed: false,
        hiddenHelp: false,
        isShowBtnCancel: false,
      },
      events: {
        "update:data": () => {},
        "update:close": () => {},
      },
    };
    EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
  } else {
    const emitData: IModalMessage = {
      component: MODAL_NAME.MODAL_RECOMMENDATION_ADD_NEW_ACTION,
    };
    EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
  }
};

const initial = async () => {
  await getCheckListData(true);
  listenEvent();
};

const getChecklistForecast = async () => {
  await store.dispatch("Recommend/fetchChecklistForecasts");
};

const getCheckListData = async (isInit = false) => {
  try {
    if (isInit) {
      loadingChecklists.value = true;
      const fetchChecklistData = await store.dispatch(
        "Recommend/fetchChecklistData",
      );
      loadingChecklists.value = false;
      if (
        !fetchChecklistData.checklists ||
        !fetchChecklistData.checklists.length
      ) {
        isDataAssessment.value = API_STATUS.NO_DATA;
        store.dispatch("Overlay/hideOverlay");
        return;
      } else {
        isDataAssessment.value = API_STATUS.HAS_DATA;
      }
      return;
    }
    loadingGetAssessmentQuestions.value = true;
    await getChecklistStatus();
    await getChecklistGroupMetricsHelper();
    await getAssessmentQuestions();
    if (dataActionTable.value.length) {
      await getChecklistForecast();
    }
  } catch (error: any) {
    loadingChecklists.value = false;
    showErrorAPI(error, Checklist.getChecklist);
  }
};

const getSuggestedActionData = async () => {
  await store.dispatch("Recommend/fetchSuggestedActionData");
};

const showError = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const getChecklistStatus = async () => {
  await store.dispatch("Recommend/fetchChecklistStatus");
};

const dataPercentile: Ref<any> = computed(() => {
  return store.state.Recommend.recommendPercentileChecklistGroupMetrics;
});
const getChecklistGroupMetricsHelper = async (isGetSuggestedAction = true) => {
  loadingActionTable.value = true;
  isGetSuggestedAction && (loadingSuggestedActionTable.value = true);
  try {
    await store.dispatch("Recommend/fetchRecomChecklistMetrics");
    await store.dispatch("Recommend/fetchRecomChecklistGroupMetrics");
    isGetSuggestedAction && (await getSuggestedActionData());
  } catch (error: any) {
    showErrorAPI(error, Checklist.createChecklistGroupMetrics);
  } finally {
    setTimeout(() => {
      loadingActionTable.value = false;
      loadingSuggestedActionTable.value = false;
    }, 500);
  }
};

const getActionScore = async (checklistGroups) => {
  const listGroupId = checklistGroups.map(
    (group: any) => group.checklistGroupId,
  );
  const res = await getChecklistGroupMetrics(
    currentChecklistReportId.value,
    listGroupId,
  );
  return checklistGroups
    .map((group: any) => {
      const groupMetric = res?.data?.data?.groupMetrics.find(
        (item) => item.checklistGroupId === group.checklistGroupId,
      );
      return {
        ...group,
        scoreIncreaseTotal: groupMetric.checklistGroupScoreMax,
      };
    })
    .sort(
      (a, b) =>
        +b.scoreIncreaseTotal.toFixed(2) -
        +b.scoreIncreaseFirstCount.toFixed(2) -
        (+a.scoreIncreaseTotal.toFixed(2) -
          +a.scoreIncreaseFirstCount.toFixed(2)),
    );
};

const refreshActions = async () => {
  try {
    await store.dispatch("Recommend/fetchRecomChecklistGroupMetrics");
    await getSuggestedActionData();
  } catch (error: any) {
    showErrorAPI(error, Checklist.createChecklistGroupMetrics);
  }
};

const getAssessmentQuestions = async () => {
  await store.dispatch("Recommend/fetchCategories");
  await store.dispatch("Recommend/fetchChecklistAssessmentQuestion");
  loadingGetAssessmentQuestions.value = false;
};

const handleSelectSuggestAction = (selectedRows: number[]) => {
  if (selectedRows.length < 1) {
    isShowMoreSuggestiongActions.value = false;
  }
  seletedSuggestActionsRow.value = dataSuggestedActionTable.value.filter(
    (item) => selectedRows.includes(item.id),
  );
};

const handleSelectAction = (selectedRows: number[]) => {
  if (selectedRows.length < 1) {
    isShowMoreActions.value = false;
  }
  seletedActionsRow.value = dataActionTable.value.filter((item) =>
    selectedRows.includes(item.id),
  );
};

const handleSelectAssessment = (selectedRows: number[]) => {
  if (selectedRows.length < 1) {
    isShowMoreAssessmentQuestionActions.value = false;
  }
  seletedAssessmentRow.value = selectedRows;
  store.commit("Recommend/SET_SELECTED_ASSESSMENT_QUESTIONS", selectedRows);
};

const handleAddAction = async (data: any | null) => {
  itemCheckedId.value = data.addedActions[0].id;
  isLoadingAPI.value = true;
  isBulkAddingActions.value = !!data?.isBulkAction;
  let dataAdd = cloneDeep(data);
  if (dataAdd.isAddAll) {
    dataAdd = {
      isSuggestionsAction: true,
      addedActions: dataSuggestedActionTable.value,
    };
  }
  try {
    const res = await store.dispatch("Recommend/createActionData", {
      isSuggestionsAction: dataAdd.isSuggestionsAction,
      checklistGroupId: dataAdd.checklistGroupId,
      addedActions: dataAdd.addedActions,
    });
    if (res && !res.error) {
      if (data.isAddAll) {
        loadingActionTable.value = true;
        const checklistGroups = await getChecklistGroups(
          currentChecklistReportId.value,
        );
        // get scoreIncreaseTotal from dataSuggestedActionTable with id
        const checklistGroupsData = await getActionScore(
          checklistGroups?.data?.data?.checklistGroups,
        );
        await store.dispatch("Recommend/bulkReorderAction", {
          checklistId: currentChecklistReportId.value,
          data: checklistGroupsData,
        });
      }
      await getChecklistGroupMetricsHelper(false);
      setTimeout(() => {
        resetSort(data.isAddAll);
      }, 300);
      if (!dataAdd.isSuggestionsAction) {
        loadingGetAssessmentQuestions.value = true;
        await getAssessmentQuestions();
        loadingGetAssessmentQuestions.value = false;
        const emitData: IToastMessage = {
          variant: ToastVariant.SUCCESS,
          message: getComponentUiText(
            dataAdd.addedActions && dataAdd.addedActions.length > 1
              ? "app-assessment-recommendations-section-action-added-actions-success-1"
              : "app-assessment-recommendations-section-action-added-action-success-1",
          ),
        };
        EventEmitter.emit(
          EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE,
          emitData,
        );
        return;
      }
    }
  } catch (error: any) {
    showErrorAPI(error, Checklist.createChecklistGroupMetrics);
  } finally {
    isLoadingAPI.value = false;
    isBulkAddingActions.value = false;
  }
  // TODO: need to another strong remove
  // if (dataAdd.isSuggestionsAction) {
  // if (dataAdd.addedActions && dataAdd.addedActions.length > 0) {
  // const addedArray = dataAdd.addedActions.map((item) => item.id);
  // const dataSuggested = dataSuggestedActionTable.value.filter(
  //   (item) => !addedArray.includes(item.id),
  // );
  // store.commit(
  //   "Recommend/SET_CHECKLIST_GROUP_TEMPLATE_METRICS",
  //   dataSuggested,
  // );
  // } else {
  // store.commit("Recommend/SET_CHECKLIST_GROUP_TEMPLATE_METRICS", []);
  // }
  // }
};

const listenEvent = () => {
  EventEmitter.on(
    EmitterEvents.ADD_NEW_ASSESSMENT_QUESTION_TO_ACTION,
    (data) => {
      processingData(data);
    },
  );
};
const isCheckedToggle = (value: boolean) => {
  isShowAppliedSuggestions.value = value;
};
const processingData = (data) => {
  if (
    seletedAssessmentRow.value.findIndex(
      (item) => item.id === data.element.id,
    ) !== -1
  ) {
    handleAddAction({
      checklistGroupId: data.checklistGroupId,
      addedActions: seletedAssessmentRow.value.map(
        (item) => item.checklistItemId,
      ),
    });
  } else
    handleAddAction({
      checklistGroupId: data.checklistGroupId,
      addedActions: [data.element.checklistItemId],
    });
};
const bulkActionAddActions = () => {
  handleAddAction({
    isSuggestionsAction: true,
    addedActions: seletedSuggestActionsRow.value,
    isBulkAction: true,
  });
  EventEmitter.emit(EmitterEvents.REMOVE_ITEM_SELECTED_ROW);
};
const isSelected = ref(false);
const onSelectChecklist = async (item: IAssessmentDetail, index: number) => {
  if (currentChecklistReportId.value === item.checklistId && isSelected.value)
    return;
  if (!isSelected.value) {
    isSelected.value = true;
  }
  localStorage.setItem(
    localStorageKey.rootChecklistReportId,
    `${checkLists.value[index].checklistId}`,
  );
  currentChain.value = index;
  EventEmitter.emit(EmitterEvents.RESET_SORT_TABLE, {
    key: RECOMMENDATION_FORCE_RESORT.isForce,
  });
  store.commit("Recommend/SET_IS_HIDE_REMOVE", false);
  await store.dispatch("Recommend/setChecklistReportId", item.checklistId);
  await store.dispatch("Sharing/setChecklistReportId", item.checklistId);
  await getCheckListData();
};

const handleShowBulkAction = () => {
  if (isChecklistStatusDone.value || !seletedSuggestActionsRow.value.length) {
    return;
  }
  isShowMoreSuggestiongActions.value = !isShowMoreSuggestiongActions.value;
};

const processRiskData = () => {
  if (!dataActionTable.value || !dataActionTable.value.length) {
    return;
  }
  let lowNumber = 0;
  let mediumNumber = 0;
  let highNumber = 0;
  let moderateNumberRelativeRisk = 0;
  let highNumberRelativeRisk = 0;
  let highestNumberRelativeRisk = 0;
  dataActionTable.value.forEach((action) => {
    action.riskDetails.forEach((risk) => {
      if (risk.riskValue > RISK_VALUE_MAP.HIGH) {
        highNumber++;
      } else if (risk.riskValue > RISK_VALUE_MAP.MEDIUM) {
        mediumNumber++;
      } else if (risk.riskValue > RISK_VALUE_MAP.LOW) {
        lowNumber++;
      }
    });
    switch (
      getTagRelativeRisk(action.relativeRiskValue, dataPercentile.value)
    ) {
      case statusCode.moderate:
        moderateNumberRelativeRisk++;
        break;
      case statusCode.high:
        highNumberRelativeRisk++;
        break;
      case statusCode.highest:
        highestNumberRelativeRisk++;
        break;
      default:
        break;
    }
  });
  listRisk.value[0].lowNumber = lowNumber;
  listRisk.value[0].mediumNumber = mediumNumber;
  listRisk.value[0].highNumber = highNumber;
  listRisk.value[1].relaModerateNumber = moderateNumberRelativeRisk;
  listRisk.value[1].relaHighNumber = highNumberRelativeRisk;
  listRisk.value[1].relaHighestNumber = highestNumberRelativeRisk;
};

const handleShowOptionActionsBulkAction = () => {
  if (isChecklistStatusDone.value || !seletedActionsRow.value.length) {
    isShowMoreActions.value = false;
    return;
  }
  isShowMoreActions.value = !isShowMoreActions.value;
};

// const bulkActionRemoveActions = async () => {
//   const emitData = {
//     component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
//     properties: {
//       value: {},
//       title: getComponentUiText("app-assess-recommend-action-delete-actions-1"),
//       description: getComponentUiText(
//         "app-assess-recommend-modal-delete-actions-description-1",
//         false,
//         { actionNumber: seletedActionsRow.value.length.toString() },
//       ),
//       buttonText: getComponentUiText(
//         "app-assess-recommend-action-delete-actions-1",
//       ),
//       additionalNote: getComponentUiText(
//         "app-assess-recommend-modal-delete-actions-note-1",
//       ),
//     },
//     events: {
//       "update:data": removeAction,
//     },
//   };
//   EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
// };

// const removeAction = async () => {
//   try {
//     await store.dispatch("Recommend/removeActions");
//     await store.commit("Recommend/SET_SELECTED_ACTIONS_ROW", []);
//     seletedActionsRow.value = [];
//     setTimeout(async () => {
//       loadingActionTable.value = true;
//       await store.dispatch("Recommend/fetchRecomChecklistGroupMetrics");
//       loadingActionTable.value = false;
//     }, 300);
//   } catch (error) {
//     showErrorAPI(error, Checklist.createChecklistGroupMetrics);
//   }
// };

const bulkUpdateStatus = async (type: number | null) => {
  isUpdatingStatus.value = true;
  try {
    const dataSelected = store.state.Recommend.selectedActionsRow;
    const finalSelectedActions: any = [];
    let body: any = null;
    dataSelected.forEach((item) => {
      switch (type) {
        case RECOMMENDATION_ACTION_PcnT.completion:
          if (!body) {
            body = {
              completionPcnt: RECOMMENDATION_ACTION_PcnT.completion,
            };
          }
          if (
            item.checklistGroupCompletionPcnt === null ||
            item.checklistGroupCompletionPcnt !==
              RECOMMENDATION_ACTION_PcnT.completion
          ) {
            finalSelectedActions.push(item);
          }
          break;

        case RECOMMENDATION_ACTION_PcnT.inProgress:
          if (!body) {
            body = {
              completionPcnt: RECOMMENDATION_ACTION_PcnT.inProgress,
            };
          }
          if (
            item.checklistGroupCompletionPcnt === null ||
            item.checklistGroupCompletionPcnt ===
              RECOMMENDATION_ACTION_PcnT.notStarted ||
            item.checklistGroupCompletionPcnt ===
              RECOMMENDATION_ACTION_PcnT.completion
          ) {
            finalSelectedActions.push(item);
          }
          break;

        case RECOMMENDATION_ACTION_PcnT.reset:
          if (!body) {
            body = {
              completionPcnt: RECOMMENDATION_ACTION_PcnT.reset,
            };
          }
          finalSelectedActions.push(item);
          break;

        case RECOMMENDATION_ACTION_PcnT.notStarted:
          if (!body) {
            body = {
              completionPcnt: RECOMMENDATION_ACTION_PcnT.notStarted,
            };
          }
          if (
            item.checklistGroupCompletionPcnt === null ||
            item.checklistGroupCompletionPcnt !==
              RECOMMENDATION_ACTION_PcnT.notStarted
          ) {
            finalSelectedActions.push(item);
          }
          break;

        case RECOMMENDATION_ACTION_PcnT.isQuickWin:
          if (!body) {
            body = {
              isQuickWin: true,
            };
          }
          if (!item.checklistGroupIsQuickWin) {
            finalSelectedActions.push(item);
          }
          break;

        case RECOMMENDATION_ACTION_PcnT.nonQuickWin:
          if (!body) {
            body = {
              isQuickWin: false,
            };
          }
          if (item.checklistGroupIsQuickWin) {
            finalSelectedActions.push(item);
          }
          break;
      }
    });
    if (finalSelectedActions.length === 0) {
      await store.commit("Recommend/SET_SELECTED_ACTIONS_ROW", []);
      return;
    }
    for (let i = 0; i < finalSelectedActions.length; i++) {
      const payload = {
        ...body,
        checklistGroupId: finalSelectedActions[i].checklistGroupId,
        checklistId: store.getters["Recommend/getChecklistReportId"],
      };
      await putChecklistGroup(payload);
    }

    await store.commit("Recommend/SET_SELECTED_ACTIONS_ROW", []);
    const currentList = cloneDeep(dataActionTable);
    finalSelectedActions.forEach((item) => {
      const index = currentList.value.findIndex(
        (action) => action.checklistGroupId === item.checklistGroupId,
      );
      if (
        body &&
        type !== RECOMMENDATION_ACTION_PcnT.isQuickWin &&
        type !== RECOMMENDATION_ACTION_PcnT.nonQuickWin
      ) {
        currentList.value[index]["checklistGroupCompletionPcnt"] =
          body["completionPcnt"];
      } else {
        currentList.value[index]["checklistGroupIsQuickWin"] =
          body["isQuickWin"];
      }
    });
    await store.commit(
      "Recommend/SET_RECOM_CHECKLIST_GROUP_METRICS",
      currentList.value,
    );
    showToastMessage(
      getComponentUiText("app-api-recommend-update-action-success-1"),
      ToastVariant.SUCCESS,
    );
  } catch (error) {
    showErrorAPI(error, Checklist.createChecklistGroupMetrics);
  } finally {
    isUpdatingStatus.value = false;
  }
};
const handleShowBulkActionAssessmentQuestions = () => {
  if (seletedAssessmentRow.value.length < 1) {
    isShowMoreAssessmentQuestionActions.value = false;
  }
  isShowMoreAssessmentQuestionActions.value =
    !isShowMoreAssessmentQuestionActions.value;
};

const actionAddActions = async () => {
  onShowAddNewActionModal();
  isShowMoreAssessmentQuestionActions.value = false;
  showBulkActionAssessmentQuestions.value = false;
};

const openRecentSearchModal = () => {
  valueSearchAssessmentQuestions = assessmentQuestionsSearchValue.value;
  isShowRecentSearch.value = true;
};

const onEnterSearchAssessmentQuestions = () => {
  if (
    assessmentQuestionsSearchValue.value &&
    assessmentQuestionsSearchValue.value !==
      lastCallApiAssessmentQuestionsSearchValue.value
  ) {
    postAndGetRecentSearch();
  }
};

const updateCurrentValueSearch = (value: string) => {
  updateModelAssessmentQuestionsSearch(value);
  assessmentQuestionsSearchValue.value = value;
};

const updateModelAssessmentQuestionsSearch = (value: string) => {
  assessmentQuestionsSearchValue.value = value;
};

const closeRecentSearchModal = () => {
  setTimeout(() => {
    isShowRecentSearch.value = false;
  }, 300);
  if (
    assessmentQuestionsSearchValue.value &&
    assessmentQuestionsSearchValue.value !==
      lastCallApiAssessmentQuestionsSearchValue.value
  ) {
    postAndGetRecentSearch();
  }
};

const postAndGetRecentSearch = async () => {
  if (
    assessmentQuestionsSearchValue.value === "" ||
    valueSearchAssessmentQuestions === assessmentQuestionsSearchValue.value
  )
    return;

  lastCallApiAssessmentQuestionsSearchValue.value =
    assessmentQuestionsSearchValue.value;

  await store.dispatch("Assessment/postRecentSearchInput", {
    searchTypeId: SEARCH_TYPE_ID.CL_INPUT,
    searchData: {
      text: assessmentQuestionsSearchValue.value,
    },
  });
  await store.dispatch("Assessment/getRecentSearches", {
    searchTypeId: SEARCH_TYPE_ID.CL_INPUT,
  });
};

watch(
  () => dataActionTable.value,
  (newValue, oldValue) => {
    if (!isEqual(newValue, oldValue)) {
      processRiskData();
    }
  },
);
</script>

<style lang="scss" scoped>
.hover-modal {
  box-shadow:
    rgba(50, 50, 93, 0.25) 0px 50px 100px -20px,
    rgba(0, 0, 0, 0.3) 0px 30px 60px -30px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  border-bottom: none;
}

#appBarLayout {
  overflow-y: hidden;
}

#body {
  flex-wrap: nowrap;
}

.main {
  background: rgba(239, 240, 241, 0.5);
  position: relative;
  height: 100%;
  overflow-y: auto;
}
.no__data {
  background: var(--UI-light-sky-soft, #e4f1ff);
  // position: relative;
  height: 100%;
  // overflow-y: auto;
}
.recommendations-container {
  max-width: 100%;
  position: relative;

  .custom-info {
    margin-top: 20px;
  }
}

.recommendations-container {
  .title {
    font-size: 22px;
    line-height: 100%;
    color: #211f58;
  }

  .sub-title {
    color: #211f58;
  }
  .overview-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(335px, 1fr));
  }
}

.header__dot {
  width: 407px;
  height: 44px;
  border-radius: 6px;
  // border: 1px solid var(--UI-rule, #eff0f1);
  background: var(--UI-white, #fff);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
}

@media (max-width: 640px) {
  .recommendations-container {
    .section-header-actions,
    .section-header-suggested {
      gap: 7px;
      flex-direction: column;
      align-items: flex-start;
    }
  }
}

@media (max-width: 1048px) {
  .recommendations-container {
    .section-header-assessment {
      gap: 7px;
      flex-direction: column;
      align-items: flex-start;
    }
  }
}

@media (max-width: 820px) {
  .recommendations-container {
    .section-header-assessment {
      .button-actions-container {
        gap: 7px;
        flex-direction: column;
        align-items: flex-start;
      }
    }
  }
  .section-title {
    flex-direction: column;
    align-items: flex-end;
    gap: 20px;
  }
  .title-text {
    width: 100%;
  }
  .header__dot {
    width: 320px;
  }
}

.toggle-switch-view {
  border-radius: 6px;
  background: var(--ui-white, #fff);
  backdrop-filter: blur(6px);
  // padding: 4px;
  align-items: center;
  display: inline-flex;

  label {
    margin-bottom: 0;
  }
  .label {
    display: flex;
    cursor: pointer;
    padding: 10px 18px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin: 0;
    color: var(--ui-light-grey, #b7b7b7);
    letter-spacing: 1px;
    border-radius: 6px;
    min-width: 16px;
    // Keep this coded out for now

    // min-width: 111px;
    // background: var(--brand-navy, #211F58);
  }

  input {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;

    &:checked + .label {
      background: var(--brand-navy, #211f58);
      color: #fff;
    }
  }
  &.setting-option-selected {
    background: var(--brand-navy, #211f58);
  }
}
:deep(.popover-body) {
  padding: 0;
  max-height: 500px;
  overflow: auto;
  span {
    font-family: Poppins;
  }
}

@media (max-width: 768px) {
  .body-container {
    padding-right: 10px;
    padding-left: 10px;
  }
}
</style>
